<template>
  <div id="app">
    <keep-alive :include="cachedViews">
      <router-view></router-view>
    </keep-alive>

  </div>
</template>

<script>
import { loadMicroApp } from "qiankun";
import router from "@/router"
import { mapState } from "vuex";
export default {
  name: "App",
  data() {
    return {
    };
  },
  computed: {
    ...mapState({
      cachedViews: state => state.tagsView.cachedViews
    })
  },
  watch: {
    $route(to, from) {
      if (to && from && to.path === from.path) {
        return;
      }
      this.$nextTick(() => {
        const app = document.getElementById("app");
        if (app) {
          app.scrollTop = 0;
        }
      });
    }
  },
  mounted() {
    // 单机运维
    if (this.$route.path.indexOf("saasH_") > -1) { //this.$route.path.indexOf("saasH_") > -1
      console.log(1111111)
      loadMicroApp({
        name: "单机运维Saas",
        entry: process.env.VUE_APP_DANJI + this.$route.path,
        container: "#app",
        props: { type: 'saas', router }
      });
    }

    if (this.$route.path.indexOf("cashierH_") > -1) {
      console.log(111111)
      loadMicroApp({
        name: "阳光收银",
        entry: process.env.VUE_APP_SHOUYIN + this.$route.path,
        container: "#app",
        props: { type: 'shouyin', router }
      });
    }
    // 权限管理
    if (this.$route.path.indexOf("/saasPer_") > -1) {
      console.log(111111)
      loadMicroApp({
        name: "权限管理",
        entry: process.env.VUE_APP_QUANXIAN + this.$route.path,
        container: "#app",
      });
    }
  },
};
</script>

<style>
#app {
  font-size: 14px;
  width: 100vw;
  height: 100vh;
  padding: 0;
  margin: 0;
  background: #000000;
  line-height: 1.3;
  overflow: hidden auto;
  scrollbar-gutter: stable;
  font-family: Tuffy;
  font-weight: 400;
  color: #FFFFFF;
}

@font-face {
  font-family: 'Tanker';
  src: url('./font/Tanker/Tanker-Regular.otf') format('opentype');
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: 'Tuffy';
  src: url('./font/Tuffy/Tuffy-Regular.ttf') format('truetype');
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: 'Tuffy';
  src: url('./font/Tuffy/Tuffy-Bold.ttf') format('truetype');
  font-weight: bold;
  font-style: normal;
}
</style>
